"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var DOMPurify = _interopRequireWildcard(require("dompurify"));

require("./InputComponent.scss");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var InputComponent = function InputComponent(_ref) {
  var width = _ref.width,
      size = _ref.size,
      placeholder = _ref.placeholder,
      allowClear = _ref.allowClear,
      name = _ref.name,
      addonBefore = _ref.addonBefore,
      addonAfter = _ref.addonAfter,
      maxLength = _ref.maxLength,
      prefix = _ref.prefix,
      suffix = _ref.suffix,
      disabled = _ref.disabled,
      defaultValue = _ref.defaultValue,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      onPressEnter = _ref.onPressEnter,
      type = _ref.type,
      className = _ref.className,
      id = _ref.id,
      value = _ref.value,
      min = _ref.min,
      autoComplete = _ref.autoComplete,
      formatter = _ref.formatter,
      parser = _ref.parser;
  var inputProps = {
    className: "".concat(className, " iiht-ant-input"),
    size: size || "medium",
    style: {
      width: width || "100%"
    },
    placeholder: placeholder,
    allowClear: allowClear,
    name: name,
    addonBefore: addonBefore,
    addonAfter: addonAfter,
    prefix: prefix,
    suffix: suffix,
    maxLength: maxLength || 70,
    disabled: disabled || false,
    defaultValue: defaultValue || "",
    onChange: onChange,
    onBlur: onBlur,
    onPressEnter: onPressEnter,
    id: id,
    value: value && DOMPurify.sanitize(value),
    min: min,
    autoComplete: autoComplete || "off",
    formatter: formatter,
    parser: parser
  };
  var numCheck = type === "number" ? /*#__PURE__*/_react["default"].createElement(_antd.InputNumber, inputProps) : /*#__PURE__*/_react["default"].createElement(_antd.Input, inputProps);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, type === "password" ? /*#__PURE__*/_react["default"].createElement(_antd.Input.Password, _extends({
    type: "password"
  }, inputProps)) : numCheck);
};

var _default = InputComponent;
exports["default"] = _default;